<template>
  <div>
    <h6>Satisfaction</h6>
    <a-rate style="font-size: 24px" :default-value="dataSuccess.ticketpoint" disabled />
  </div>
</template>

<script>
export default {
  props: {
    dataSuccess: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
};
</script>